export default "__VITE_ASSET__DoBSuvQ___"